// src/components/ui/buttons/DefectButtons.tsx
import { Button, Box } from "@mui/material";

interface Props {
  onChange: (delta: number) => void;
  disabled?: boolean;
}

export const DefectButtons = ({ onChange, disabled }: Props) => (
  <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
    <Button
      variant="outlined"
      onClick={() => onChange(-1)}
      color="error"
      size="small"
      sx={{ minWidth: 40, minHeight: 40 }}
      disabled={disabled}
    >
      -
    </Button>
    <Button
      variant="outlined"
      onClick={() => onChange(1)}
      color="error"
      size="small"
      sx={{ minWidth: 40, minHeight: 40 }}
      disabled={disabled}
    >
      +
    </Button>
  </Box>
);
